/**
 * Function that receive an entity list and a name
 * to filter in the list.
 * @param entityList => Entity array (Temporalically any type)
 * @param name => Entity name
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function filterByName(entityList: any[], name: string, key = 'name'): any[] {
  return entityList.filter((item) => item[key].toLowerCase().includes(name.toLowerCase()));
}

export default filterByName;
